import * as ApiManager from './_manager';
import store from '@/store';

export const screener = {
  create: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/create`,
      payload
    );
  },

  get: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/get`,
      payload
    );
  },
  getDraftScreener: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/getDraftScreener`,
      payload
    );
  },
  discardScreener: (payload = null) => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/discardScreener`,
      payload
    );
  },

  list: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/list`,
      payload
    );
  },

  delete: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/delete`,
      payload
    );
  },

  update: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/update`,
      payload
    );
  },

  removeGeoBlocking: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/removeGeoBlocking`,
      payload
    );
  },

  sendNotification: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/sendNotification`,
      payload
    );
  },

  downloadAllConsumers: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.screener_id +
        `/consumer/download`,
      payload
    );
  },

  getStreams: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/streams/get`,
      payload
    );
  },

  saveStreams: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/streams/save`,
      payload
    );
  },

  broadcastStream: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/stream/broadcast`,
      payload
    );
  },

  deactiveStream: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/stream/deactive`,
      payload
    );
  },

  setPreRoll: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/` +
        payload.id +
        `/setPreRoll`,
      payload
    );
  },

  upgrade: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/upgrade`,
      payload
    );
  },
  markUpgraded: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/markUpgraded`,
      payload
    );
  },
  updateSeats: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/updateSeats`,
      payload
    );
  },
  listPaymentTransactions: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/listPaymentTransactions`,
      payload
    );
  },
  importConsumers: payload => {
    return ApiManager.callApi (
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.get ('screener_id')}/import-consumers`,
      payload
    );
  },
  getSeatsStatus: (payload) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/getSeatsStatus`,
      payload,
    );
  },
  updatePhysicalVenueSeats: (payload) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/updatePhysicalVenueSeats`,
      payload,
    );
  },
  updateCategoriesPricing: (payload) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/updateCategoriesPricing`,
      payload,
    );
  },
  updateTicketTypesDiscount: (payload) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/updateTicketTypesDiscount`,
      payload,
    );
  },
  updateScreenerChatroom: (payload) => {
    return ApiManager.callApi(
      `/member/company/${store.getters['company/getSelected']}/screener/${payload.screener_id}/updateScreenerChatroom`,
      payload,
    );
  }
};
